import type {
  PropertyServiceStatusFilters,
  PropertyServiceStatusResponse,
} from "@mysnowscape/snow-lib";
import axios from "./backendAxios";

type GetPropertyServiceStatusArgs = {
  searchPhrase: string | null;
  filters: PropertyServiceStatusFilters;
  take: number;
  skip: number;
};

export function buildServiceStatusParams({
  searchPhrase,
  filters,
  take,
  skip,
}: GetPropertyServiceStatusArgs): URLSearchParams {
  const params = new URLSearchParams({
    take: String(take),
    skip: String(skip),
    "filter[season]": filters.season,
    "filter[hours]": String(filters.hours),
    "filter[serviceStatus]": filters.serviceStatus,
  });

  if (filters.companies.length > 0) {
    params.set("filter[companies]", filters.companies.join(","));
  }
  if (filters.routes.length > 0) {
    params.set("filter[routes]", filters.routes.join(","));
  }
  if (filters.city) {
    params.set("filter[city]", filters.city);
  }
  if (searchPhrase?.trim()) {
    params.set("searchPhrase", searchPhrase.trim());
  }

  return params;
}

async function getLivePropertyServiceStatus(
  args: GetPropertyServiceStatusArgs,
): Promise<PropertyServiceStatusResponse> {
  const params = buildServiceStatusParams(args);
  const res = await axios.get<PropertyServiceStatusResponse>(
    `job/service-status?${params.toString()}`,
  );
  return res.data;
}

const propertyServiceStatus = {
  getPropertyServiceStatus: async (
    args: GetPropertyServiceStatusArgs,
  ): Promise<PropertyServiceStatusResponse> =>
    getLivePropertyServiceStatus(args),
};

export default propertyServiceStatus;
